import React, { useEffect, useState, useRef, useMemo } from "react";
import { Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import { saveAs } from 'file-saver';
import JSZip from "jszip";
import _ from "lodash";
import {
  BootstrapTooltip,
  context_styles
} from "../../mi_styles";
import "../../mi.css";
import axios from "axios";
import { styled } from '@mui/material/styles';
import { Tag } from 'antd';
import { makeStyles } from '@mui/styles';
import { Chip } from '@mui/material';
import moment from "moment";
import { useSpring, animated } from '@react-spring/web';
import { useSelector, useDispatch } from "react-redux";
import { Projects } from "../../miComponents/projects";
import { StyledAutocompleteDark } from "../../miComponents/styled_autocomplete";
import { StyledDatePicker } from "../../miComponents/styledDatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TextField from "@mui/material/TextField";
import { miActions, miImageActions, miAuditSearchActions } from "../../../store/store";
import { miAuditSearchSlice } from "../../../store/motorInsurance/miAuditSearchSlice";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CarPartsForm from "./carPart";
const generateImageUrl = (imageName) => {
  return "https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditImages/" + imageName + "?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D"
}

const colors = [
  'magenta',
  'red',
  'volcano',
  'orange',
  'gold',
  'lime',
  'green',
  'cyan',
  'blue',
  'geekblue',
  'purple',
];

export default function AuditSearch(props) {
  const {
    color,
    col_100
  } = useSelector(state => state.miStore);

  const {
    searchedDate, selectedAudit, allAudits, auditDetails, allAuditDetailsByDate
  } = useSelector(state => state.miAuditSearchStore);


  const [date, setDate] = useState(null);
  const [audits, setAudits] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [auditData, setAuditData] = useState([]);
  const [tags, setTags] = useState({
    'AI answer': true,
    'HI answer': true,
    'Disable Boxes': true
  });
  // const [classesData, setClassesData] = useState([]);
  const [showCarPartsForm, setShowCarPartsForm] = useState(false);

  const handleShowCarPartsForm = () => {
    setShowCarPartsForm(true);
  };


  const StyledChip = styled(Chip)(({ theme }) => ({
    backgroundColor: col_100,
    color: "rgba(245, 245, 245, 0.75)"
  }));

  const useAutoCompleteStyles = makeStyles({
    option: {
      fontSize: '0.875rem',
    },
  });
  const dispatch = useDispatch();
  const autocomplete_classes = useAutoCompleteStyles();

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0
    },
    config: {
      mass: 7,
    }
  }))

  useEffect(() => {
    api.start({
      from: {
        opacity: 0,
        y: -15 + "%"
      },
      to: {
        opacity: 1,
        y: 0 + "%"
      }
    })
  }, [])

  const handleDateChange = async (newDate) => {
    const formattedDate = moment(newDate).format("YYYY-MM-DD");
    setDate(formattedDate);
    dispatch(miAuditSearchSlice.actions.setSearchedDate(formattedDate));

    dispatch(miActions.setLoading(true));
    axios.post('/miAuditSearch/getFiltersByDate', { date: formattedDate })
      .then(result => {
        const auditList = [...new Set(result.data.map(r => r.audit_id))];
        // console.log('result', result);
        dispatch(miAuditSearchSlice.actions.setAudits(auditList));
        setAudits(auditList);
        dispatch(miAuditSearchSlice.actions.setAllAuditDetailsByDate(result.data));
        // setAuditData(result.data);
        dispatch(miActions.setLoading(false));
      })
      .catch(error => {
        console.log('error', error);
        dispatch(miActions.setLoading(false));
      })
  }

  const handleFilterOptionChange = (e, type) => {
    setSelectedFilter(e);
    console.log('selected audit', e);
    dispatch(miAuditSearchSlice.actions.setSelectedAudit(e));

    if (e) {
      const filteredAuditDetails = allAuditDetailsByDate.filter(r => r.audit_id === e);
      // console.log(filteredAuditDetails, "130")
      dispatch(miAuditSearchActions.setAuditDetails(filteredAuditDetails))
    }
  }

  const renderSelectedOptions = (selectedOptions, { inputValue }) => {
    /**
     * The delete option in the chip is not configured (yet...)
     */
    let displayedOptions = selectedOptions.slice(0, 0);

    if (selectedOptions.length > 0) {
      const remainingCount = selectedOptions.length;
      const remainingOptions = `+${remainingCount}`;
      displayedOptions = displayedOptions.concat(remainingOptions);
    }

    return (
      <div>
        {displayedOptions.map((option, index) => (
          <StyledChip
            size="small"
            key={index}
            label={option}
            onDelete={() => handleFilterOptionChange(option, "")}
          />
        ))}
      </div>
    );
  };

  const toggleTag = (tag) => {
    const updatedTags = {
      ...tags,
      [tag]: !tags[tag]
    }

    setTags(updatedTags)
    dispatch(miImageActions.setBoxTags(updatedTags))
  }

  const colorProfiles = {
    "AI answer": {
      col: "rgb(0, 255, 179)",
      col_100: "rgba(0, 255, 179, 0.2)"
    },
    "HI answer": {
      col: "rgb(255, 30, 244)",
      col_100: "rgba(255, 30, 244, 0.2)"
    },
    "Disable Boxes": {
      col: color,
      col_100: col_100
    }
  }
  const get_image_url = (imageName) => {
    const url =
      "https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditImages/" +
      imageName +
      "?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D";
    return url;
  };
  // const handleCloseCarPartsForm = () => {
  //   setShowCarPartsForm(false);
  // };

  const handleCloseCarPartsForm = () => {
    // Close the form and trigger a success message
    setShowCarPartsForm(false);
    toast.success('Part details updated successfully!', {
      position: 'bottom-center',
      autoClose: 3000, // Toast auto-closes after 3 seconds
      hideProgressBar: true,
    });
  };

  return (
    <Paper elevation={10} sx={context_styles}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <StyledDatePicker
          sx={{
            width: "15rem",
            boxSizing: "border-box",
            paddingTop: '0.5em',
            borderRadius: "5px",
          }}
          value={searchedDate}
          onChange={(newDate) => handleDateChange(newDate)}
          renderInput={(params) => (
            <TextField variant="outlined" size="small" {...params} />
          )}
          format="YYYY-MM-DD"
        />
      </LocalizationProvider>
      {allAudits.length > 0 &&
        <StyledAutocompleteDark
          sx={{ width: "15rem" }}
          classes={{
            option: autocomplete_classes.option,
          }}
          id="size-small-outlined-multi"
          size="small"
          noOptionsText="data not available"
          value={selectedAudit}
          componentsProps={{ popper: { style: { width: 'fit-content' } } }}
          options={allAudits}
          getOptionLabel={(option) => option}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" placeholder={`Audits   ( ${allAudits.length} )`} />
          )}
          renderTags={renderSelectedOptions}
          onChange={(event, value) => handleFilterOptionChange(value, "audit")}
        />}
      <div style={{ width: "100%", padding: "0.5rem 1rem", display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center", gap: "1rem" }}>
        {selectedAudit && <button
          style={{
            outline: "none",
            border: "none",
            backgroundColor: "#181b20",
            border: "1px solid grey",
            padding: "0.2rem 1rem",
            borderRadius: "5px",
            color: "grey",
            cursor: "pointer",
          }}
          onClick={handleShowCarPartsForm}
        >
          Update Part Details
        </button>}

        {showCarPartsForm && (
          <div style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "1.5rem",
            borderRadius: "8px",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
            width: "80%",
            maxHeight: "70%",
            overflowY: "auto",
            zIndex: 1000
          }}>
            <CarPartsForm handleClose={handleCloseCarPartsForm} />
          </div>
        )}
      </div>
      <ToastContainer />
      <Projects />
    </Paper>
  )
}